(function () {
  function initCard(card) {
    var swatches = card.querySelectorAll('.lumora-product__color');
    if (!swatches.length) return;

    var modeImages = card.querySelectorAll('.lumora-product__mode-image');
    var activeImg = card.querySelector('.lumora-product__mode-image--active') || card.querySelector('.lumora-product__image');
    if (!activeImg) return;
    var originalSources = new Map();
    modeImages.forEach(function (image) { originalSources.set(image, image.getAttribute('src')); });
    var defaultSrc = activeImg.getAttribute('src');
    var selectedSwatch = card.querySelector('.lumora-product__color.active') || swatches[0];

    function setActive(target) {
      swatches.forEach(function (swatch) { swatch.classList.remove('active'); });
      if (target) target.classList.add('active');
    }

    function showSwatch(swatch) {
      if (modeImages.length) {
        modeImages.forEach(function (image) {
          var mode = image.getAttribute('data-mode');
          var url = swatch && (swatch.getAttribute('data-color-' + mode) || swatch.getAttribute('data-color-image'));
          image.setAttribute('src', url || originalSources.get(image));
        });
      } else {
        var url = swatch && swatch.getAttribute('data-color-image');
        activeImg.setAttribute('src', url || defaultSrc);
      }
    }

    function restoreSelected() {
      setActive(selectedSwatch);
      showSwatch(selectedSwatch);
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('mouseenter', function () {
        setActive(swatch);
        showSwatch(swatch);
      });
      swatch.addEventListener('mouseleave', restoreSelected);
      swatch.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        selectedSwatch = swatch;
        restoreSelected();
      });
    });

    // Align the initial photo set with the preselected variant, including shared media.
    restoreSelected();
  }

  function init() {
    document.querySelectorAll('.lumora-product').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
